import { Box } from '@chakra-ui/react';
import Header from '../../../components/header/Header';
import FundersList from '../../../components/funders/FundersList';

const Funders = () => {
  return (
    <Box>
      <Header title="Funders" />
      <Box className="p-4 bg-[#f0f0f0]">
        <FundersList />
      </Box>
    </Box>
  );
};

export default Funders;
